import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import structuredClone from '@ungap/structured-clone';
import { Subscription } from 'rxjs';
import { Choice } from 'src/app/shared/components/select/choice.model';

import { NavigationService } from '../services/navigation.service';
import { TaskListModeEnum } from '../shared/enums';
import { Filter, TaskListConfiguration } from '../shared/models';
import { FiltersService } from './filters.service';

@Component({
  selector: 'app-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss'],
})
export class FiltersComponent implements OnInit, OnDestroy {
  @Input() taskListConfiguration: TaskListConfiguration;
  @Input() taskListMode: TaskListModeEnum;

  tplFilters: Filter[];
  rawFilters: Filter[];
  isFiltersSelected = false;
  stateInboxNg = 'auth.alcmeon.inbox.list';

  private subscriptions = new Subscription();

  constructor(
    private filtersService: FiltersService,
    private navigationService: NavigationService,
    @Inject('$state') private $state: any
  ) {}

  ngOnInit() {
    if (this.taskListConfiguration.filters?.length) {
      this.filtersService.validateRoutingFilter(this.taskListConfiguration);
      this.rawFilters = this.filtersService.filters;
    } else {
      this.rawFilters = this.filtersService.buildInitialFilters();
    }

    this.initIsFiltersSelected();
    this.prepareTplFilters();

    this.subscriptions.add(
      this.filtersService.updateTplFiltersBS.subscribe(() => {
        this.rawFilters = this.filtersService.filters;
        this.prepareTplFilters();
      })
    );
  }

  initIsFiltersSelected() {
    const isFilterSelected = this.rawFilters.some(filter => {
      return filter.selected;
    });

    this.isFiltersSelected = isFilterSelected || this.isFiltersSelected;
    this.filtersService.isFiltersOrSitesSelected = this.isFiltersSelected;
  }

  sitesChange(sites: string[]) {
    this.isFiltersSelected = !!sites.length || this.isFiltersSelected;
    this.filtersService.isFiltersOrSitesSelected = this.isFiltersSelected;
  }

  resetFilters() {
    this.filtersService.resetfilters();
    this.navigationService.setSelectedSiteIdsAndUpdateAvailableTaskListConfigs([], []);
    this.reloadTaskList(true);
  }

  prepareTplFilters() {
    this.tplFilters = structuredClone(this.rawFilters);

    this.tplFilters.forEach(filter => {
      filter.choices = filter.items as Choice[];
      filter.control = new FormControl(filter.selected);

      if (!filter.items?.length) {
        filter.control.disable();
      } else {
        this.subscriptions.add(
          filter.control.valueChanges.subscribe((value: string[]) => {
            this.onChangeFilter(filter, value);
          })
        );
      }
    });
  }

  private onChangeFilter(changedFilter: Filter, value: any) {
    const changedFilterIndex = this.rawFilters.findIndex(filter => {
      if (filter.type === changedFilter.type) {
        filter.selected = value;
        return true;
      }
    });

    this.filtersService.saveSelectedFilter(changedFilter.type, value);
    this.filtersService.setSelectedFilter(this.rawFilters[changedFilterIndex]);
    this.reloadTaskList(false);
  }

  reloadTaskList(allChannels: boolean) {
    // we could do this.$state.reload(), but it have a 1+ sec unexpected latency
    this.$state.go(
      `${this.stateInboxNg}.tasks`,
      {
        queueId: this.taskListConfiguration.queueId,
        channelQueueId: allChannels ? 'all' : this.taskListConfiguration.channelQueueId,
      },
      {
        reload: this.stateInboxNg,
      }
    );
  }

  ngOnDestroy(): void {
    this.subscriptions?.unsubscribe();
  }
}
